<template>
  <span class="ctrl-100 ctrl">
    <el-button
      class="ctrl-btn"
      :class="{ active: joinRoomModal }"
      @click="toggleVisibility"
      type="text"
    >
      <IconBase
        :height="32"
        :width="32"
        :view-box="`0 0 32 32`"
        :fill="'#E7E6FA'"
        class="ctrl-icon"
      >
        <IconBackArrow />
      </IconBase>
      All to lobby
    </el-button>
    <div
      class="ctrl-window__overlay"
      v-if="joinRoomModal"
      @click="joinRoomModal = false"
    ></div>
    <transition name="fade">
      <div class="ctrl-window" v-if="joinRoomModal" width="30%">
        <div class="ctrl__header">
          <h3 class="ctrl__title">Return all to lobby</h3>
          <div @click="joinRoomModal = false">
            <IconBase
              :height="24"
              :width="24"
              :view-box="`0 0 24 24`"
              :fill="'#E7E6FA'"
            >
              <IconCross />
            </IconBase>
          </div>
        </div>
        <div class="lobby-text">
          Make all the participants leave their rooms to join the lobby after 30
          secs?
        </div>
        <span slot="footer" class="ctrl__footer">
          <el-button @click="joinRoomModal = false">Cancel</el-button>
          <el-button @click="notifyUsers" type="primary">Confirm</el-button>
        </span>
      </div>
    </transition>
  </span>
</template>

<script>
import IconBase from "../IconBase";
import IconBackArrow from "../icons/IconBackArrow";
import IconCross from "../icons/IconCross";
import { mapState, mapGetters } from "vuex";
import { getSocketPayload } from "../../utils";

export default {
  name: "JoinRoom",
  components: {
    IconBase,
    IconBackArrow,
    IconCross
  },

  data: function() {
    return {
      joinRoomModal: false
    };
  },

  methods: {
    toggleVisibility() {
      this.joinRoomModal = !this.joinRoomModal;
    },
    notifyUsers: function() {
      this.joinRoomModal = false;
      this.socket.emit(
        "FORCE_TO_LOBBY",
        getSocketPayload({
          token: this.tokens ? this.tokens["idToken"] : null,
          mainRoom: this.roomToJoin.name,
          roomId: this.roomToJoin._id
        })
      );
    }
  },
  computed: {
    ...mapState({
      roomToJoin: state => state.rooms.mainRoom,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket"
    })
  }
};
</script>

<style scoped>
.door-open:hover {
  fill: #409eff;
}

.door-open {
  fill: #f7f7f7;
}

.lobby-text {
  color: #e7e6fa;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 24px;
}
.ctrl-icon {
  display: block;
}
</style>
